//@ts-check
import React from 'react';
import { Communication } from 'ecrion-components';

/**
 * @param {import('./types').PrivateCommunicationProps} param
 */
const Private = ({
  title,
  onClose,
  communicationName,
  communicationId,
  jobId,
  user,
}) => {
  const [job, setJob] = React.useState(null);

  const context = {};

  context['UserName'] = user.LoginName;
  context['Email'] = user.Email;
  context['AccountId'] = user.AccountId;
  context['UAID'] = user.Contact && user.Contact.UAID;

  const onJobStarted = (jobSummary) => {
    if (!jobSummary) return;

    const { Id, Workspace } = jobSummary;
    setJob({ jobId: Id, workspace: Workspace });
  };

  if (job)
    return (
      <Communication.Run.JobDetails
        jobId={job.jobId}
        workspace={job.workspace}
        toolbar={{ title: title || job.JobName, onClose }}
        projectId={communicationId}
        projectName={communicationName}
        variant="portal"
      />
    );

  return (
    <>
      <Communication.Run.Frame
        title={title}
        onClose={onClose}
        projectId={communicationId}
        projectName={communicationName}
        jobId={jobId}
        onJobStarted={onJobStarted}
        context={context}
        disableRepositoryAccess // repository access not available for running in portal
        variant="portal"
        showToolbar
      />
    </>
  );
};

export default Private;
